/* eslint-disable */
'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true,
})

var _slicedToArray = (function () {
  function sliceIterator(arr, i) {
    var _arr = []
    var _n = true
    var _d = false
    var _e = undefined
    try {
      for (
        var _i = arr[Symbol.iterator](), _s;
        !(_n = (_s = _i.next()).done);
        _n = true
      ) {
        _arr.push(_s.value)
        if (i && _arr.length === i) break
      }
    } catch (err) {
      _d = true
      _e = err
    } finally {
      try {
        if (!_n && _i['return']) _i['return']()
      } finally {
        if (_d) throw _e
      }
    }
    return _arr
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i)
    } else {
      throw new TypeError(
        'Invalid attempt to destructure non-iterable instance'
      )
    }
  }
})()
//leaflet

//pixi-overlay

// react-leaflet

var _react = require('react')

var _leaflet = require('leaflet')

var _leaflet2 = _interopRequireDefault(_leaflet)

var _pixi = require('pixi.js')

var PIXI = _interopRequireWildcard(_pixi)

require('leaflet-pixi-overlay')

var _reactLeaflet = require('react-leaflet')

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj
  } else {
    var newObj = {}
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key))
          newObj[key] = obj[key]
      }
    }
    newObj.default = obj
    return newObj
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

PIXI.settings.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = false
PIXI.utils.skipHello()
var PIXILoader = PIXI.Loader.shared

var PixiOverlay = function PixiOverlay(_ref) {
  var markers = _ref.markers
  var enableDragDispatch = _ref.enableDragDispatch || false
  var onDragStateChange = _ref.onDragStateChange || null

  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    openedPopupData = _useState2[0],
    setOpenedPopupData = _useState2[1]

  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    openedTooltipData = _useState4[0],
    setOpenedTooltipData = _useState4[1]

  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    openedPopup = _useState6[0],
    setOpenedPopup = _useState6[1]

  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    openedTooltip = _useState8[0],
    setOpenedTooltip = _useState8[1]

  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    pixiOverlay = _useState10[0],
    setPixiOverlay = _useState10[1]

  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    loaded = _useState12[0],
    setLoaded = _useState12[1]

  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    circleDraw = _useState14[0],
    setCircleDraw = _useState14[1]

  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    polygonDraw = _useState16[0],
    setPolygonDraw = _useState16[1]

  var _useState17 = (0, _react.useState)(null),
    _useState18 = _slicedToArray(_useState17, 2),
    areasDraw = _useState18[0],
    setAreasDraw = _useState18[1]

  var map = (0, _reactLeaflet.useMap)()

  // Estado de drag persistente via useRef — sobrevive a re-execuções do useEffect
  var dragStateRef = (0, _react.useRef)({
    isDragging: false,
    dragClone: null,
    dragData: null,
    closestDeviceTarget: null,
    clickDetection: { moved: false, startTime: 0 },
    markerSpriteId: null,
    onDragEnd: null,
    codeDispatch: null,
    onClick: null,
    markerId: null,
  })

  // Ref para indicar que houve mudança de markers durante drag e precisa redesenhar
  var pendingRedrawRef = (0, _react.useRef)(false)

  // Counter para forçar re-execução do useEffect de desenho após drag
  var _useStateRedraw = (0, _react.useState)(0),
    _useStateRedraw2 = _slicedToArray(_useStateRedraw, 2),
    redrawTrigger = _useStateRedraw2[0],
    setRedrawTrigger = _useStateRedraw2[1]

  var [openedTooltipArr, setOpenedTooltipArr] = _react.useState([])

  if (map.getZoom() === undefined) {
    // this if statment is to avoid getContainer error
    // map must have zoom prop
    console.error(
      'no zoom found, add zoom prop to map to avoid getContainer error'
    )
    return null
  }

  // load sprites
  ;(0, _react.useEffect)(
    function () {
      // cancel loading if already loading as it may cause: Error: Cannot add resources while the loader is running.
      if (PIXILoader.loading) {
        PIXILoader.reset()
      }

      var loadingAny = false
      var _iteratorNormalCompletion = true
      var _didIteratorError = false
      var _iteratorError = undefined

      try {
        for (
          var _iterator = markers[Symbol.iterator](), _step;
          !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
          _iteratorNormalCompletion = true
        ) {
          var marker = _step.value

          var resolvedMarkerId = marker.iconId || marker.iconColor

          // skip if no ID or already cached
          if (
            (!marker.iconColor && !marker.iconId) ||
            PIXILoader.resources['marker_' + resolvedMarkerId]
          ) {
            continue
          }
          loadingAny = true

          PIXILoader.add(
            'marker_' + resolvedMarkerId,
            marker.customIcon
              ? getEncodedIcon(marker.customIcon)
              : getDefaultIcon(marker.iconColor)
          )
        }
      } catch (err) {
        _didIteratorError = true
        _iteratorError = err
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return()
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError
          }
        }
      }

      if (loaded && loadingAny) {
        setLoaded(false)
      }

      if (loadingAny) {
        PIXILoader.load(function () {
          return setLoaded(true)
        })
      } else {
        setLoaded(true)
      }
    },
    [markers]
  )

  // load pixi when map changes
  ;(0, _react.useEffect)(
    function () {
      var pixiContainer = new PIXI.Container()
      var overlay = _leaflet2.default.pixiOverlay(
        function (utils) {
          // redraw markers
          var scale = utils.getScale()
          utils.getContainer().children.forEach(function (child) {
            return child.scale.set(1 / scale)
          })

          utils.getRenderer().render(utils.getContainer())
        },
        pixiContainer,
        {
          forceCanvas: true,
          preserveDrawingBuffer: false,
        }
      )
      overlay.addTo(map)
      setPixiOverlay(overlay)
      if (circleDraw) {
        map.removeLayer(circleDraw)
      }
      if (polygonDraw) {
        map.removeLayer(polygonDraw)
      }
      if (areasDraw) {
        pixiContainer.removeChildren()
      }
      setCircleDraw(null)
      setAreasDraw(null)

      // setOpenedPopupData(null);
      // setOpenedTooltipData(null);

      return function () {
        return pixiContainer.removeChildren()
      }
    },
    [map]
  )

  // draw markers first time in new container
  ;(0, _react.useEffect)(
    function () {
      if (pixiOverlay && markers && loaded) {
        var utils = pixiOverlay.utils
        var container = utils.getContainer()
        var renderer = utils.getRenderer()
        var project = utils.latLngToLayerPoint
        var scale = utils.getScale()

        // Se drag ativo, atualizar posições dos sprites existentes sem destruí-los
        // Isso preserva o clone fantasma, event handlers e o estado de drag
        if (dragStateRef.current.isDragging) {
          container.children.forEach(function (child) {
            if (child.markerData && child !== dragStateRef.current.dragClone) {
              var matchingMarker = markers.find(function (m) { return m.id === child.markerData.id })
              if (matchingMarker && matchingMarker.position) {
                var newCoords = project(matchingMarker.position)
                child.x = newCoords.x
                child.y = newCoords.y
                // Atualizar dados de posição armazenados no sprite
                child.markerData.position = matchingMarker.position
              }
            }
          })
          renderer.render(container)
          pendingRedrawRef.current = true
          return
        }

        // Limpar sprites antigos antes de reconstruir
        // (cobre o caso em que a cleanup foi pulada durante drag ativo)
        container.removeChildren()

        if (circleDraw) {
          map.removeLayer(circleDraw)
        }
        if (polygonDraw) {
          map.removeLayer(polygonDraw)
        }
        if (areasDraw) {
          map.removeLayer(areasDraw)
        }

        setOpenedTooltipArr([])

        // Array para armazenar referências de todos os sprites para detecção de colisão
        var allSprites = []

        markers.forEach(function (marker) {
          var id = marker.id,
            iconColor = marker.iconColor,
            iconId = marker.iconId,
            onClick = marker.onClick,
            position = marker.position,
            popup = marker.popup,
            tooltip = marker.tooltip,
            tooltipOptions = marker.tooltipOptions,
            markerSpriteAnchor = marker.markerSpriteAnchor,
            angle = marker.angle,
            circleBase = marker.circleBase,
            polygon = marker.polygon,
            groupMarker = marker.groupMarker,
            areas = marker.areas,
            deviceHistoric = marker.deviceHistoric,
            onDragEnd = marker.onDragEnd,
            codeDispatch = marker.codeDispatch,
            deviceName = marker.deviceName  
          var resolvedIconId = iconId || iconColor
          if (
            !PIXILoader.resources['marker_' + resolvedIconId] ||
            !PIXILoader.resources['marker_' + resolvedIconId].texture
          ) {
            return
          }

          var markerTexture =
            PIXILoader.resources['marker_' + resolvedIconId].texture
          //const markerTexture = new PIXI.Texture.fromImage(url);

          markerTexture.anchor = { x: 0.5, y: 1 }
          if (groupMarker != 'areas') {
            var markerSprite = PIXI.Sprite.from(markerTexture)
            if (markerSpriteAnchor) {
              markerSprite.anchor.set(
                markerSpriteAnchor[0],
                markerSpriteAnchor[1]
              )
            } else {
              markerSprite.anchor.set(0.5, 1)
            }

            var markerCoords = project(position)
            markerSprite.x = markerCoords.x
            markerSprite.y = markerCoords.y
            // Armazenar dados do marcador no sprite para detecção de colisão
            markerSprite.markerData = {
              id: id,
              groupMarker: groupMarker,
              position: position,
              iconColor: iconColor,
              codeDispatch: codeDispatch,
              deviceName: deviceName,
            }


            if (circleBase) {
              if (circleDraw != null) {
                map.removeLayer(circleDraw)
              }
              var circleActual = _leaflet2.default.circle(position, {
                radius: 500,
              })
              setCircleDraw(circleActual)
              circleActual.addTo(map)
            }

            if (angle) {
              markerSprite.angle = angle
            }

            markerSprite.scale.set(1 / scale)

            if (popup || onClick || tooltip) {
              markerSprite.interactive = true
            }

            // 🎯 IMPLEMENTAÇÃO DO DRAG AND DROP: DISPATCH → DEVICE (Ghost Clone)
            if (groupMarker === 'dispatch' && enableDragDispatch && onDragEnd) {
              markerSprite.eventMode = 'static'
              markerSprite.cursor = 'grab'

              var currentCircle = circleBase ? circleActual : null

              // Função para encontrar o device mais próximo colidindo com o sprite arrastado
              var findClosestDevice = function (draggedSprite) {
                var draggedBounds = draggedSprite.getBounds()
                var draggedCenterX = draggedBounds.x + draggedBounds.width / 2
                var draggedCenterY = draggedBounds.y + draggedBounds.height / 2
                var closestDevice = null
                var closestDistance = Infinity

                // Restaurar visual de todos os device sprites primeiro
                allSprites.forEach(function (otherSprite) {
                  if (otherSprite.markerData.groupMarker !== 'device') return
                  if (otherSprite._dragOriginalTint !== undefined) {
                    otherSprite.tint = otherSprite._dragOriginalTint
                    delete otherSprite._dragOriginalTint
                  }
                  if (otherSprite._dragOriginalScale !== undefined) {
                    otherSprite.scale.set(otherSprite._dragOriginalScale)
                    delete otherSprite._dragOriginalScale
                  }
                })

                allSprites.forEach(function (otherSprite) {
                  // Filtrar APENAS devices
                  if (otherSprite.markerData.groupMarker !== 'device') return
                  if (otherSprite === draggedSprite) return

                  var otherBounds = otherSprite.getBounds()

                  // Verificar colisão AABB
                  var isColliding =
                    draggedBounds.x < otherBounds.x + otherBounds.width &&
                    draggedBounds.x + draggedBounds.width > otherBounds.x &&
                    draggedBounds.y < otherBounds.y + otherBounds.height &&
                    draggedBounds.y + draggedBounds.height > otherBounds.y

                  if (isColliding) {
                    var otherCenterX = otherBounds.x + otherBounds.width / 2
                    var otherCenterY = otherBounds.y + otherBounds.height / 2
                    var dx = draggedCenterX - otherCenterX
                    var dy = draggedCenterY - otherCenterY
                    var distance = Math.sqrt(dx * dx + dy * dy)

                    if (distance < closestDistance) {
                      closestDistance = distance
                      closestDevice = otherSprite
                    }
                  }
                })

                // Aplicar feedback visual ao device mais próximo (tint verde + escala ampliada)
                if (closestDevice) {
                  if (closestDevice._dragOriginalTint === undefined) {
                    closestDevice._dragOriginalTint = closestDevice.tint
                  }
                  if (closestDevice._dragOriginalScale === undefined) {
                    closestDevice._dragOriginalScale = closestDevice.scale.x
                  }
                  closestDevice.tint = 0x00ff00
                  closestDevice.scale.set(
                    closestDevice._dragOriginalScale * 1.3
                  )
                }

                return closestDevice ? closestDevice.markerData : null
              }

              // Restaurar visual de todos os device sprites
              var restoreAllDeviceVisuals = function () {
                allSprites.forEach(function (sprite) {
                  if (sprite.markerData.groupMarker !== 'device') return
                  if (sprite._dragOriginalTint !== undefined) {
                    sprite.tint = sprite._dragOriginalTint
                    delete sprite._dragOriginalTint
                  }
                  if (sprite._dragOriginalScale !== undefined) {
                    sprite.scale.set(sprite._dragOriginalScale)
                    delete sprite._dragOriginalScale
                  }
                })
              }

              // Remover clone fantasma do container
              var removeDragClone = function () {
                if (dragStateRef.current.dragClone) {
                  try {
                    container.removeChild(dragStateRef.current.dragClone)
                    dragStateRef.current.dragClone.destroy()
                  } catch (e) {
                    // Clone já pode ter sido removido pelo cleanup do useEffect
                  }
                  dragStateRef.current.dragClone = null
                }
              }

              markerSprite.on('pointerdown', function (event) {
                dragStateRef.current.clickDetection = { moved: false, startTime: Date.now() }
                dragStateRef.current.isDragging = true
                dragStateRef.current.dragData = event.data
                dragStateRef.current.closestDeviceTarget = null
                dragStateRef.current.onDragEnd = onDragEnd
                dragStateRef.current.codeDispatch = codeDispatch
                dragStateRef.current.onClick = onClick
                dragStateRef.current.markerId = id

                // Criar clone fantasma na mesma posição do original
                var clone = PIXI.Sprite.from(markerTexture)
                clone.anchor.set(markerSprite.anchor.x, markerSprite.anchor.y)
                clone.x = markerSprite.x
                clone.y = markerSprite.y
                clone.scale.set(markerSprite.scale.x, markerSprite.scale.y)
                clone.alpha = 0.7
                container.addChild(clone)
                dragStateRef.current.dragClone = clone

                this.cursor = 'grabbing'

                map.dragging.disable()
                map.doubleClickZoom.disable()

                if (onDragStateChange) onDragStateChange(true)

                event.stopPropagation()
              })

              markerSprite.on('pointermove', function (event) {
                var ds = dragStateRef.current
                if (ds.isDragging && ds.dragData && ds.dragClone) {
                  ds.clickDetection.moved = true

                  var newPosition = ds.dragData.getLocalPosition(container)
                  ds.dragClone.x = newPosition.x
                  ds.dragClone.y = newPosition.y

                  // Esconder polígono durante drag
                  if (polygon && polygonDraw) {
                    map.removeLayer(polygonDraw)
                  }

                  // Encontrar o device mais próximo colidindo com o clone
                  ds.closestDeviceTarget = findClosestDevice(ds.dragClone)

                  renderer.render(container)
                }
              })

              markerSprite.on('pointerup', function (event) {
                var ds = dragStateRef.current
                if (ds.isDragging) {
                  var clickDuration = Date.now() - ds.clickDetection.startTime
                  var wasClick = !ds.clickDetection.moved && clickDuration < 200

                  this.cursor = 'grab'

                  // Remover clone fantasma
                  removeDragClone()

                  map.dragging.enable()
                  map.doubleClickZoom.enable()

                  // Restaurar visual de todos os devices
                  restoreAllDeviceVisuals()

                  var cachedOnDragEnd = ds.onDragEnd
                  var cachedCodeDispatch = ds.codeDispatch
                  var cachedOnClick = ds.onClick
                  var cachedMarkerId = ds.markerId
                  var cachedClosestDevice = ds.closestDeviceTarget
                  var cachedMoved = ds.clickDetection.moved

                  // Resetar estado de drag
                  ds.isDragging = false
                  ds.closestDeviceTarget = null
                  ds.dragData = null

                  if (wasClick && cachedOnClick) {
                    cachedOnClick(cachedMarkerId)
                  } else if (
                    cachedMoved &&
                    cachedClosestDevice &&
                    cachedOnDragEnd
                  ) {
                    cachedOnDragEnd({
                      dispatchMarkerId: cachedMarkerId,
                      deviceMarkerId: cachedClosestDevice.id,
                      codeDispatch: cachedCodeDispatch,
                      deviceName: cachedClosestDevice.deviceName,
                    })
                  }

                  if (onDragStateChange) onDragStateChange(false)

                  // Se houve redesenho pendente durante o drag, forçar agora
                  if (pendingRedrawRef.current) {
                    pendingRedrawRef.current = false
                    setRedrawTrigger(function (c) { return c + 1 })
                  }

                  renderer.render(container)
                }
              })

              markerSprite.on('pointerupoutside', function () {
                var ds = dragStateRef.current
                if (ds.isDragging) {
                  // Remover clone fantasma
                  removeDragClone()

                  // Restaurar visual de todos os devices
                  restoreAllDeviceVisuals()

                  this.cursor = 'grab'

                  map.dragging.enable()
                  map.doubleClickZoom.enable()

                  var cachedOnDragEnd = ds.onDragEnd
                  var cachedCodeDispatch = ds.codeDispatch
                  var cachedMarkerId = ds.markerId
                  var cachedClosestDevice = ds.closestDeviceTarget
                  var cachedMoved = ds.clickDetection.moved

                  // Resetar estado de drag
                  ds.isDragging = false
                  ds.closestDeviceTarget = null
                  ds.dragData = null

                  // Se soltou sobre um device válido, chamar onDragEnd
                  if (
                    cachedMoved &&
                    cachedClosestDevice &&
                    cachedOnDragEnd
                  ) {
                    cachedOnDragEnd({
                      dispatchMarkerId: cachedMarkerId,
                      deviceMarkerId: cachedClosestDevice.id,
                      codeDispatch: cachedCodeDispatch,
                      deviceName: cachedClosestDevice.deviceName,
                    })
                  }

                  if (onDragStateChange) onDragStateChange(false)

                  // Se houve redesenho pendente durante o drag, forçar agora
                  if (pendingRedrawRef.current) {
                    pendingRedrawRef.current = false
                    setRedrawTrigger(function (c) { return c + 1 })
                  }

                  renderer.render(container)
                }
              })
            }

            if (polygon) {
              const poliref = _leaflet2.default.polygon(polygon, {
                color: 'blue',
              })
              markerSprite.on('mouseover', function () {
                // Dispatch markers com drag ativo não devem exibir polígono
                if (groupMarker === 'dispatch' && dragStateRef.current.isDragging) return
                map.removeLayer(poliref)
                setPolygonDraw(poliref)
                poliref.addTo(map)
              })
              markerSprite.on('mouseout', function () {
                if (groupMarker === 'dispatch' && dragStateRef.current.isDragging) return
                map.removeLayer(poliref)
              })
            }

            if (popup || onClick) {
              if (groupMarker !== 'dispatch' || !onDragEnd) {
                // Prevent accidental launch of onClick event when dragging the map.
                // Detect very small moves as clicks.
                markerSprite.on('mousedown', function () {
                  var moveCount = 0
                  markerSprite.on('mousemove', function () {
                    moveCount++
                  })
                  markerSprite.on('mouseup', function () {
                    if (moveCount < 2 && onClick) {
                      onClick(id)
                    }
                  })
                })
                // Prevent the same thing on touch devices.
                markerSprite.on('touchstart', function () {
                  var moveCount = 0
                  markerSprite.on('touchmove', function () {
                    moveCount++
                  })
                  markerSprite.on('touchend', function () {
                    if (moveCount < 10 && onClick) {
                      onClick(id)
                    }
                  })
                })

                markerSprite.cursor = 'pointer'
              }

              markerSprite.buttonMode = true
            }

            if (tooltip) {
              if (typeof openedTooltipArr == 'object') {
                if (
                  Boolean(openedTooltipArr.findIndex((val) => val.id == id))
                ) {
                  setOpenedTooltipArr(
                    openedTooltipArr.push({
                      id: id,
                      offset: [7, -25],
                      position: position,
                      content: tooltip,
                      tooltipOptions: tooltipOptions || {},
                    })
                  )

                  openTooltip(map, {
                    id: id,
                    offset: [7, -25],
                    position: position,
                    content: tooltip,
                    tooltipOptions: tooltipOptions || {},
                  }).addTo(map)
                }
              }
            }

            container.addChild(markerSprite)

            // Adicionar sprite ao array de todos os sprites para detecção de colisão
            allSprites.push(markerSprite)
          } else {
            if (areas) {
              if (areas.length > 1) {
                areas.map((area) => {
                  var poly = new PIXI.Polygon(
                    area.verticesPoint?.map((vertice) =>
                      utils.latLngToLayerPoint(vertice)
                    )
                  )
                  var graphics = new PIXI.Graphics()

                  graphics.beginFill(area.color, 0.1)
                  graphics.lineStyle(1, area.color, 1)
                  graphics.drawShape(poly)
                  graphics.interactive = true

                  graphics.on('touchmove', function () {
                    graphics.removeLayer(poly),
                      setAreasDraw(poly),
                      graphics.drawShape(poly)
                  })

                  const tooltipMapLeaflet = openTooltip(map, {
                    id: id,
                    offset: [7, -25],
                    position: area.verticesPoint[0],
                    content: tooltip,
                    tooltipOptions: tooltipOptions || {},
                  })

                  graphics.on('mouseover', () => {
                    tooltipMapLeaflet.addTo(map)
                  })

                  graphics.on('mouseout', () => {
                    tooltipMapLeaflet.removeFrom(map)
                  })

                  container.addChild(graphics)
                  setAreasDraw(graphics)
                })
              } else {
                var newAreas = areas[0].verticesPoint

                var poly = new PIXI.Polygon(
                  newAreas?.map((vertice) => utils.latLngToLayerPoint(vertice))
                )
                var graphics = new PIXI.Graphics()
                graphics.beginFill(areas.color, 0.3)
                graphics.lineStyle(1, areas.color, 5)
                graphics.drawShape(poly)
                graphics.interactive = true
                const tooltipMapLeaflet = openTooltip(map, {
                  id: id,
                  offset: [7, -25],
                  position: newAreas[0],
                  content: tooltip,
                  tooltipOptions: tooltipOptions || {},
                })

                graphics.on('mouseover', () => {
                  tooltipMapLeaflet.addTo(map)
                })

                graphics.on('mouseout', () => {
                  tooltipMapLeaflet.removeFrom(map)
                })
                container.addChild(graphics)
                setAreasDraw(graphics)
              }
            }
          }
        })

        renderer.render(container)
      }

      return function () {
        if (pixiOverlay) {
          // Se drag ativo: NÃO destruir sprites/clone — manter tudo vivo
          // O early return no próximo efeito marcará pendingRedraw
          // A limpeza será feita no início do rebuild quando o drag terminar
          if (dragStateRef.current.isDragging) {
            return
          }
          pixiOverlay.utils.getContainer().removeChildren()
        }
      }
    },
    [pixiOverlay, markers, loaded, redrawTrigger]
  )
  // handle tooltip
  ;(0, _react.useEffect)(
    function () {
      if (typeof openedTooltipArr == 'object') {
        map.eachLayer(function (layer) {
          if (layer.options.pane === 'tooltipPane') layer.removeFrom(map)
        })
        openedTooltipArr.map((tooltip) => openTooltip(map, tooltip))
      }

      // we don't want to reload when openedTooltip changes as we'd get a loop
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [markers]
  )

  // handle popup
  // (0, _react.useEffect)(function () {
  //   // close only if different popup
  //   if (openedPopup) {
  //     map.removeLayer(openedPopup);
  //   }

  //   // open only if new popup
  //   if (openedPopupData) {
  //     setOpenedPopup(openPopup(map, openedPopupData, { autoClose: false }));
  //   }

  //   // we don't want to reload when whenedPopup changes as we'd get a loop
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [openedPopupData, map]);

  return null
}

// function openPopup(map, data) {
//   var extraOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
//   // var isPopup = arguments[3];

//   var popup = _leaflet2.default.popup(Object.assign({ offset: data.offset }, {extraOptions})).setLatLng(data.position).setContent(data.content).addTo(map);

//   // TODO don't call onClick if opened a new one
//   // if (isPopup && data.onClick) {
//   //   popup.on("remove", function () {
//   //     data.onClick(null);
//   //   });
//   // }

//   return popup;
// }

function openTooltip(map, data) {
  var tooltip = _leaflet2.default
    .tooltip(
      Object.assign(
        { offset: data.offset, permanent: true },
        data.tooltipOptions
      )
    )
    .setLatLng(data.position)
    .setContent(data.content)

  return tooltip
}

function getDefaultIcon(color) {
  var svgIcon =
    '<svg style="-webkit-filter: drop-shadow( 1px 1px 1px rgba(0, 0, 0, .4));filter: drop-shadow( 1px 1px 1px rgba(0, 0, 0, .4));" xmlns="http://www.w3.org/2000/svg" fill="' +
    'green' +
    '" width="36" height="36" viewBox="0 0 24 24"><path d="M12 0c-4.198 0-8 3.403-8 7.602 0 6.243 6.377 6.903 8 16.398 1.623-9.495 8-10.155 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.342-3 3-3 3 1.343 3 3-1.343 3-3 3z"/></svg>'
  return getEncodedIcon(svgIcon)
}

function getEncodedIcon(svg) {
  var decoded = unescape(encodeURIComponent(svg))
  var base64 = btoa(decoded)
  return 'data:image/svg+xml;base64,' + base64
}

exports.default = PixiOverlay
